import { render, staticRenderFns } from "./DIDs.vue?vue&type=template&id=601984b7&scoped=true&"
import script from "./DIDs.vue?vue&type=script&lang=js&"
export * from "./DIDs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601984b7",
  null
  
)

export default component.exports